// extracted by mini-css-extract-plugin
export default {"loadingDots":"wrapped_loading_dots-module___loadingDots___ea64b9b6"};